import React from 'react'
import css from './style.css'
import { Grid, GridItem } from '../grid'

const JewelryPhoto = props => {
  const imgClasses = (options = { external: false }) => [
    options.external ? css.externalImg : css.noImg,
    props.summary ? css.summary : '',
    css.jewelry
  ].join(' ')

  const renderImage = (imageUrl) => {
    return <div className={imgClasses()} />
  }

  return (
    <Grid>
      <GridItem col='1/2'>
        {renderImage(props.firstImageURL)}
      </GridItem>
    </Grid>
  )
}

export default JewelryPhoto



// WEBPACK FOOTER //
// ./src/components/jewelry-photo/index.js